import { Avatar, CircularProgress, FormHelperText } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { find } from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FormControl } from './index';
import { ListItem, ListItemText, Stack, Typography } from 'node_modules/@mui/material/index';

const MultiValueAutocomplete = (props) => {
  const {
    options,
    name,
    label,
    value,
    loading,
    required,
    fullWidth,
    helperText,
    getOptionLabel,
    getOptionValue,
    variant,
    isImage,
    isSubLabel,
    isLabelType,
    getOptionSubLabel,
  } = props;

  const getLabel = (element) => {
    if (element && element[getOptionLabel]) {
      return element[getOptionLabel];
    } else {
      return '';
    }
  };
  const getSubLabel = (element) => {
    if (element && element[getOptionSubLabel]) {
      return element[getOptionSubLabel];
    } else {
      return '';
    }
  };

  const getValue = (element) => element[getOptionValue];

  const setValue = (value) => {
    if (value) {
      props.onChange(value);
    } else {
      props.onChange([]);
    }
  };

  const defaultValue = value ? value.map((option) => option.label) : [];
  let finalOptions = [];

  if (options && options.length > 0) {
    options.forEach((element) => {
      const object = {
        label: getLabel(element),
        ...(isImage && { image: element?.resource_image }),
        ...(isSubLabel && { description: getSubLabel(element) }),
        ...(isLabelType && { skill_type: element?.skill_type?.name }),
        value: getValue(element),
      };
      if (!find(value, { value: object?.value })) {
        finalOptions.push(object);
      }
    });
  }

  return (
    <FormControl key={`key${name}`} error={helperText ? true : false} fullWidth={fullWidth} required={required}>
      <Autocomplete
        multiple
        // filterSelectedOptions={false}
        options={finalOptions}
        defaultValue={defaultValue}
        value={value}
        loading={loading}
        onChange={(event, newValue) => {
          if (event?.type === 'click') {
            setValue(newValue);
          }
        }}
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            <ListItemText
              primary={
                <Stack spacing={0.2}>
                  <Typography component="p" variant="caption">
                    {option?.skill_type}
                  </Typography>
                  <Typography component="p" variant="subtitle1">
                    {option?.label}
                  </Typography>
                </Stack>
              }
              secondary={option?.description}
            />
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            error={helperText ? true : false}
            {...params}
            label={label}
            variant={variant}
            required={required}
            InputProps={{
              ...params.InputProps,
              autoComplete: 'off', // disable autocomplete and autofill
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

MultiValueAutocomplete.defaultProps = {
  name: '',
  label: '',
  value: [],
  url: '',
  required: false,
  fullWidth: true,
  helperText: '',
  getOptionLabel: 'name',
  getOptionSubLabel: 'description',
  getOptionValue: 'id',
  filter: [],
  loading: false,
  options: [],
  onChange: () => {},
  variant: 'outlined',
};

MultiValueAutocomplete.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.array,
  url: PropTypes.string,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  getOptionLabel: PropTypes.string,
  getOptionSubLabel: PropTypes.string,
  getOptionValue: PropTypes.string,
  filter: PropTypes.array,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  options: PropTypes.array,
  variant: PropTypes.string,
};

export default MultiValueAutocomplete;
